<script>
  import { Faq } from '$client';
  export let data;
  $: faq = data.faq;
</script>

<section id="main" class="margin-block" itemscope itemtype="https://schema.org/FAQPage">
  <Faq type="page" data={faq} />
</section>
